<template>

  <div class="flags">
    <div class="flag" :class="{'active': lang == 'de-DE'}" @click="langSwitch('de-DE')">
      <flag iso="de"></flag>
    </div>
    <div class="flag" :class="{'active': lang == 'en-GB'}" @click="langSwitch('en-GB')">
      <flag iso="gb"></flag>
    </div>
  </div>

</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex'

import '../../icons'

export default {
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    ...mapMutations(['switchLang']),
    langSwitch (lang) {
      this.$i18n.locale = lang
      this.switchLang(lang)
    }
  }
}
</script>

<style scoped lang="stylus" src="../../styles/_Flags.styl"/>



// WEBPACK FOOTER //
// src/components/common/Flags.vue